import email from './email'
import page from './page'

const entities = {
  email,
  page
}

export default entities
